<template>
    <div>
        <el-dialog
            title="提示"
            :visible.sync="centerDialogVisible"
            :append-to-body="true"
            :modal-append-to-body="false"
            :close-on-click-modal="false"
            width="30%"
            height="30%"
            center
        >
            <!-- <span>请输入密码</span>
            <span slot="footer" class="dialog-footer">
                <div style="display: flex; justify-content: center; margin-top: 20px">
                    <el-button type="primary" @click="toExport">确认</el-button>

                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </span>
            <el-form ref="form" label-width="80px" style="overflow-y: auto; margin-top: 20px">
                <el-form-item label="密码:" label-width="120px">
                    <el-input v-model="export_password" style="width: 150px; margin-right: 5px"> </el-input>
                </el-form-item>
            </el-form> -->
         

        
            <div style="text-align: center">请输入密码:  <el-input v-model="export_password" style="width: 150px; margin-right: 5px"> </el-input></div>

             
  
            <span slot="footer" class="dialog-footer">
                <div style="display: flex; justify-content: center; margin-top: 20px">
                    <el-button type="primary" @click="toExport">确认</el-button>

                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </span>
        </el-dialog>
    </div>
</template>

<script>
var _this, t;
export default {
    props: {
        isShow: Boolean,
        data: {}
    },
    watch: {
        isShow(newData, oldData) {
            _this.centerDialogVisible = true;
            _this.submit_data = _this.data;
        }
    },

    data() {
        return {
            centerDialogVisible: false,

            export_password: '',

            // 导出密码验证规则
            message_rules: {
                placeholder: '导出密码',
                rules: {
                    required: true,
                    message: '导出密码不能为空',
                    regulation: 'elt_str',
                    rulesData: 6
                }
            }
        };
    },

    created() {
        _this = this;
    },
    methods: {
        toExport() {
            console.log('密码页面toExpor方法');

            _this.submit_data.export_password = _this.export_password;


            // 通知父组件导出完毕
            _this.$emit('passwordSuccess', _this.export_password);

            // 关闭弹出框
            _this.closeDialog();
        
          
    
            // _this.getExcelData();




            // _this.progress_show = true;
            // console.log(_this.progress_show);
        

            // _this.getExcelData();
        },

        // 关闭方法
        closeDialog() {
            _this.export_password = '';
            _this.centerDialogVisible = false;
        },
        // toJSON() {
        //     _this.submit_data.other_item = JSON.stringify(_this.other_items);
        //     _this.pwd_isShow = !_this.pwd_isShow;
        // },
        // passwordSuccess(val) {
        //     console.log(val);
        //     _this.submit_data.export_password = val;

        //     _this.getExcelData();

        //     _this.progress_show = true;
        // },
       

        
        
    }
};
</script>